module.exports = __webpack_public_path__ + "img/logo.9c51ff4e.svg";